/**
 * Hubwayz certification / controlled-test voucher reference (Phase 2L / 2O).
 *
 * Applies ONLY to hotels-only cert/test Book payloads.
 * Do NOT change customer-facing voucher email behavior.
 *
 * API accept ≠ email delivery — see Phase 2L post-Book checklist.
 */

/** Cert/test voucher inbox — supplier reference.voucherEmail for controlled Book only. */
export const HUBWAYZ_CERT_TEST_VOUCHER_EMAIL = "op@hotelsriver.com";

/**
 * Authorized TEST booker contact for Hubwayz certification Books.
 * Phone required by Mishor schema (a205); FAQ allows "N/A" but international
 * format preferred when country matches search (IL). Owner-authorized TEST only.
 */
export const HUBWAYZ_CERT_TEST_CONTACT = Object.freeze({
  email: HUBWAYZ_CERT_TEST_VOUCHER_EMAIL,
  phone: "+972501112233",
  country: "IL",
  address: "N/A",
  city: "N/A",
  state: "N/A",
  zip: "00000",
});

/**
 * Build reference block for hotels-only cert Book dry-run / future gated Book.
 * @param {string} bookingAttemptId
 */
export function buildHubwayzCertTestReference(bookingAttemptId) {
  const agency = String(bookingAttemptId || "").trim();
  if (!agency) {
    return {
      ok: false,
      error: {
        code: "missing_attempt_id",
        message: "bookingAttemptId required for cert reference.agency",
      },
    };
  }
  return {
    ok: true,
    reference: {
      agency,
      voucherEmail: HUBWAYZ_CERT_TEST_VOUCHER_EMAIL,
    },
  };
}

/** Top-level customer node for hotels-only cert Book (TEST guests). */
export function buildHubwayzCertTestCustomer(partial = {}) {
  const name = partial.name || {};
  const contact = {
    ...HUBWAYZ_CERT_TEST_CONTACT,
    ...(partial.contact || {}),
  };
  return {
    title: partial.title || "M",
    name: {
      first: String(name.first || "Cert").trim() || "Cert",
      last: String(name.last || "Adultone").trim() || "Adultone",
    },
    contact: {
      email: String(contact.email || HUBWAYZ_CERT_TEST_VOUCHER_EMAIL).trim(),
      phone: String(contact.phone || HUBWAYZ_CERT_TEST_CONTACT.phone).trim(),
      country: String(contact.country || "IL")
        .trim()
        .toUpperCase()
        .slice(0, 2),
      address: String(contact.address || "N/A").trim() || "N/A",
      city: String(contact.city || "N/A").trim() || "N/A",
      state: String(contact.state || "N/A").trim() || "N/A",
      zip: String(contact.zip || "00000").trim() || "00000",
    },
    ...(partial.birthDate ? { birthDate: String(partial.birthDate).trim() } : {}),
  };
}
